import { useTranslation } from "react-i18next";
import { AppButton } from "@/components/ui";
import { AlertCircle } from "lucide-react";
import type { AuthError as AuthErrorType } from "../../types/auth";

interface AuthErrorProps {
  error: AuthErrorType;
  onRetry: () => void;
}

export function AuthError({
  error,
  onRetry,
}: AuthErrorProps): React.ReactElement {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col items-center gap-8 text-center"
      role="alert"
      aria-live="assertive"
    >
      <div className="flex w-20 h-20 items-center justify-center rounded-3xl bg-danger/10 shadow-inner">
        <AlertCircle className="w-10 h-10 text-danger" />
      </div>
      <div className="space-y-2">
        <p className="text-lg text-foreground">{t(error.messageKey)}</p>
      </div>
      <AppButton
        variant="ghost"
        onPress={onRetry}
        className="text-sm font-bold text-success hover:underline transition-colors"
      >
        {t("auth.errors.retry")}
      </AppButton>
    </div>
  );
}
